// EmailJS Configuration

export const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_hd13b8o', // Get from EmailJS dashboard
  TEMPLATE_ID: 'template_fvphkj8', // Get from EmailJS dashboard
  PUBLIC_KEY: 'RhcCaa_nphDENqUb2', // Get from EmailJS dashboard
  RECIPIENT_EMAIL: 'cylostream0@gmail.com'
};

/*
 * INSTRUCTIONS FOR SETTING UP EMAILJS:
 * 
 * 1. Sign up at https://www.emailjs.com/ (they have a free tier)
 * 2. Create a new service connected to your email (Gmail, Outlook, etc.)
 * 3. Create an email template with the following variables:
 *    - {{from_name}} - The name of the person contacting you
 *    - {{from_email}} - The email of the person contacting you
 *    - {{subject}} - The subject of the message
 *    - {{message}} - The content of the message
 * 4. Get your Service ID, Template ID, and Public Key from the EmailJS dashboard
 * 5. Replace the placeholder values in this file with your actual values
 */ 